<template>
  <CheckStart />
</template>
<script route="/set_up_shop/thrid_shop">
  import CheckStart from './thridShop.jsx'
  export default {
    components: { CheckStart }
  }
</script>
